import localeManager from './localeManager';

export const defaults = {
  title: 'HOP',
  description:
    'Brindamos soluciones logísticas eficaces y ofrecemos la mejor experiencia en seguimiento y distribución de paquetería.',
  image: 'https://static.hopenvios.com.ar/imagenes-hop/share.jpg',
  siteName: 'HOP',
  locale: 'es-AR'
};
/**
 * Genera metadatos SEO dinámicos basados en el locale y los datos proporcionados.
 *
 * @param {Object} data - Datos para generar los metadatos.
 * @param {string} data.locale - Locale actual ('es-AR', 'es-UY', 'es-PE', etc.).
 * @param {string} data.title - Título de la página.
 * @param {string} data.description - Descripción de la página.
 * @param {string} data.pathname - Ruta relativa de la página.
 * @param {string} data.image - Ruta relativa de la imagen a usar.
 * @returns {Object} - Objeto con metadatos optimizados para SEO.
 */
export default function getMetadata(data) {
  const locale = data.locale || defaults.locale;
  const baseUrl = localeManager.getBaseUrl(locale);
  const sanitizedUrl = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;

  const title = data.title ? `${data.title} | ${defaults.title}` : defaults.title;
  const description = data.description || defaults.description;
  const images = [
    { url: data.image ? `${sanitizedUrl}${data.image}` : defaults.image }
  ];

  const fullPathname = data.pathname?.startsWith('/')
  ? data.pathname
  : `/${data.pathname || ''}`; 

const url = `${sanitizedUrl}${fullPathname}`;

  return {
    title,
    description,
    canonical: url,
    openGraph: {
      locale,
      title,
      description,
      images,
      url,
      siteName: defaults.siteName,
      type: 'website'
    },
    twitter: {
      title,
      description,
      images,
      card: 'summary_large_image'
    }
  };
}
